import { ru, type Locale, en } from '@repo/go-ui';
import type { Locale as DateFnsLocale } from 'date-fns';
import { enUS as enLocale, es as esLocale, ru as ruLocale } from 'date-fns/locale';

import { requireService } from 'src/packages/di';

const uiLocales: Record<string, Locale> = {
  ru,
  en,
};

export function getLocale(lang: string): Locale {
  const i18 = requireService('i18');
  const uiLocale = uiLocales[lang] ?? en;

  return {
    ...uiLocale,
    calendar: {
      locale: getDateFnsLocale(lang),
      values: {
        hour: i18.t('common:DatePicker.hour'),
        minuteShort: i18.t('common:DatePicker.minuteShort'),
      },
    },
    input: {
      values: {
        clear: i18.t('common:DatePicker.clear'),
      },
    },
    datePicker: {
      values: {
        apply: i18.t('common:DatePicker.apply'),
        cancel: i18.t('common:Buttons.cancel'),
      },
    },
  };
}

function getDateFnsLocale(lang: string): DateFnsLocale {
  switch (lang) {
    case 'ru':
      return ruLocale;
    case 'es':
      return esLocale;
    case 'en':
    default:
      return enLocale;
  }
}
